(() => {
  const desktop = () => window.matchMedia('(min-width: 990px)').matches;
  let lightbox;
  let lastTrigger;

  function createLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'bw-product-lightbox';
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML = '<button class="bw-product-lightbox__close" type="button" aria-label="Close image preview">×</button><img class="bw-product-lightbox__image" alt="">';
    lightbox.querySelector('.bw-product-lightbox__close').addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
    document.body.appendChild(lightbox);
    return lightbox;
  }

  function openLightbox(image, trigger) {
    const overlay = createLightbox();
    const preview = overlay.querySelector('.bw-product-lightbox__image');
    lastTrigger = trigger;
    preview.src = image.currentSrc || image.src || image.getAttribute('data-src');
    preview.alt = image.alt || 'Product image preview';
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bw-lightbox-open');
    overlay.querySelector('.bw-product-lightbox__close').focus();
  }

  function closeLightbox() {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bw-lightbox-open');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }

  function goMobileSlide(gallery, direction) {
    const slider = gallery.mainSlider && gallery.mainSlider.instance;
    if (slider) {
      slider.go(direction);
      return;
    }
    // The slider initializes shortly after load; retry once without breaking navigation.
    window.setTimeout(() => {
      const delayedSlider = gallery.mainSlider && gallery.mainSlider.instance;
      if (delayedSlider) delayedSlider.go(direction);
    }, 180);
  }

  function mountMobileArrows() {
    if (desktop()) {
      document.querySelectorAll('.bw-gallery-arrow').forEach((button) => button.remove());
      return;
    }

    document.querySelectorAll('product-media').forEach((gallery) => {
      const root = gallery.querySelector('[data-main-product-slider]');
      if (!root || root.dataset.slidesCount === '1' || root.querySelector('.bw-gallery-arrow')) return;
      root.style.position = 'relative';
      [['prev', '<'], ['next', '>']].forEach(([name, symbol]) => {
        const button = document.createElement('button');
        button.className = `bw-gallery-arrow bw-gallery-arrow--${name}`;
        button.type = 'button';
        button.setAttribute('aria-label', name === 'prev' ? 'Previous product image' : 'Next product image');
        button.textContent = symbol;
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          goMobileSlide(gallery, name === 'prev' ? '<' : '>');
        });
        root.appendChild(button);
      });
    });
  }

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeLightbox(); });

  // Capture phase runs before Mojave's modal-opener handler, so the unstable full-page modal never gets control.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.main-product__media-modal-opener--image');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (!desktop()) return;
    const item = trigger.closest('.main-product__media-item') || trigger.parentElement;
    const image = item && item.querySelector('img');
    if (image) openLightbox(image, trigger.querySelector('button') || trigger);
  }, true);

  document.addEventListener('DOMContentLoaded', mountMobileArrows);
  window.addEventListener('resize', mountMobileArrows);
})();
